const initBarba = () => {
	window.scrollTo(0, 0); //reset scroll

	//Hacky way to get barba to ignore the admin bar links, doing this cleanly in a hook didn't work...
	document.querySelectorAll("#wpadminbar a").forEach(item=>item.setAttribute('data-barba-prevent','self'));

	//const thirdPartyCookiesAccepted = parseInt(gdprConsent.gdpr_consent__thirdparty) === 1 ? true : false;

	barba.hooks.before((data) => {
		// Disabling barba transitions for woocommerce pages.
		// Necessary to ensure that WC JS gets loaded on checkout/product pages
		if (isWoocommerceUrl(data.next.url.href)) {
			barba.force(data.next.url.href);
		}
	});

	barba.hooks.after(() => {
		if (thirdPartyCookiesAccepted && typeof ga === 'function') {
			ga('set', 'page', window.location.pathname);
			ga('send', 'pageview');
		}
	});

	barba.init({
		transitions: [
			{
				name: 'default',
				sync: true,
				leave(data) {
					const done = this.async();

					document.querySelector('body').classList.add('loading');
					document.querySelector('.js__barba-transition').classList.add('loading');

					window.scrollTo(0, 0); //reset scroll

					done();
				},
				after() {
					// Re-init js
					init();



					setTimeout(function () {
						document.querySelector('.js__barba-transition').classList.add('loaded');
						document.querySelector('body').classList.remove('loading');
						document.querySelector('body').classList.remove('has-nav-overlay');
						
					}, 650);

					setTimeout(function () {
						document.querySelector('.js__barba-transition').classList.remove('loading');
						document.querySelector('.js__barba-transition').classList.remove('loaded');
					}, 1000);

					// Reinit the form. Calling it in transitions so it doesn't run when page is loaded without barba
					if (wpcf7) {
						let forms = document.querySelectorAll('.wpcf7 > form');
						if (forms.length) {
							forms.forEach((form) => wpcf7.init(form));
						}
					}
				},
			},
		],
		views: [
			{
				namespace: 'default',
				afterEnter() {},
			},
		],
	});


	init();
};
